/* TALU anchor scroll - 2026-05-19 v2
   Intercepta clicks en anchors y scrollea con offset = nav.height + announcement + buffer.
   Re-scrollea en window.load y +800ms para compensar imagenes hero que cargan despues
   y empujan las secciones hacia abajo (causa de off-by-one observado en mobile).
*/
(function () {
  'use strict';

  var BUFFER = 24;

  function getOffsetTop() {
    var nav = document.querySelector('.nav, nav.nav');
    var ann = document.querySelector('.announcement-bar:not([hidden]):not([aria-hidden="true"])');
    var navH = nav ? nav.getBoundingClientRect().height : 0;
    var annH = (ann && ann.offsetParent !== null) ? ann.getBoundingClientRect().height : 0;
    return navH + annH + BUFFER;
  }

  function scrollToTarget(target, smooth) {
    if (!target) return;
    var offset = getOffsetTop();
    var top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
  }

  function ensurePosition(target, attempts) {
    // Re-scroll en cada intervalo asegurando que termina en la posicion correcta
    // aunque imagenes/fonts/GSAP cambien la altura del documento.
    attempts = attempts || 0;
    if (attempts > 6) return;
    scrollToTarget(target, attempts === 0);
    setTimeout(function () { ensurePosition(target, attempts + 1); }, attempts === 0 ? 200 : 250);
  }

  function handleClick(e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href) return;
    var hashMatch = href.match(/(^|\/[^#]*)?#([\w-]+)$/);
    if (!hashMatch) return;
    var hash = '#' + hashMatch[2];

    var url;
    try { url = new URL(a.href, location.origin); } catch { return; }
    var samePath = url.pathname === location.pathname || (url.pathname === '/' && location.pathname === '/');
    if (!samePath) return;

    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    ensurePosition(target);
    history.replaceState(null, '', hash);
  }

  function handleHashOnLoad() {
    if (!location.hash) return;
    var target;
    try { target = document.querySelector(location.hash); } catch { return; }
    if (!target) return;

    // Scroll inicial inmediato (instant, sin smooth para que no se note el flicker)
    scrollToTarget(target, false);

    // Re-scroll en cada momento clave: DOMContentLoaded, load, +800ms, +1500ms
    var checkpoints = [
      function (cb) {
        if (document.readyState !== 'loading') cb();
        else document.addEventListener('DOMContentLoaded', cb, { once: true });
      },
      function (cb) {
        if (document.readyState === 'complete') cb();
        else window.addEventListener('load', cb, { once: true });
      },
      function (cb) { setTimeout(cb, 400); },
      function (cb) { setTimeout(cb, 800); },
      function (cb) { setTimeout(cb, 1500); }
    ];
    checkpoints.forEach(function (cp) {
      cp(function () { scrollToTarget(target, false); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.addEventListener('click', handleClick);
      handleHashOnLoad();
    });
  } else {
    document.addEventListener('click', handleClick);
    handleHashOnLoad();
  }

  window.addEventListener('hashchange', function () {
    var target;
    try { target = document.querySelector(location.hash); } catch { return; }
    if (target) ensurePosition(target);
  });
})();
